<template>
    <div class="status-wa-list">
        <div class="m-d-16" v-for="(data, idx) in dataList" :key="`${idx}-${data.id}`">
            <SOSlotCard
                :id="`status-${data.id}`"
                :card-type="'none'"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
                :last-id="getLastId"
            >
                <template v-slot:before_head>
                    <div class="wa-device-container">
                        <span class="wa-device f-regular f-12 f-c-midgrey">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.02664 1.33354C4.38664 1.33354 1.41997 4.3002 1.41997 7.9402C1.41997 9.10687 1.72664 10.2402 2.29997 11.2402L1.36664 14.6669L4.86664 13.7469C5.8333 14.2735 6.91997 14.5535 8.02664 14.5535C11.6666 14.5535 14.6333 11.5869 14.6333 7.94687C14.6333 6.1802 13.9466 4.5202 12.7 3.27354C12.0888 2.65615 11.3608 2.16665 10.5584 1.83357C9.75603 1.50049 8.89538 1.33051 8.02664 1.33354ZM8.0333 2.44687C9.49997 2.44687 10.8733 3.0202 11.9133 4.0602C12.4237 4.57044 12.8284 5.17641 13.1041 5.84338C13.3798 6.51034 13.5211 7.22517 13.52 7.94687C13.52 10.9735 11.0533 13.4335 8.02664 13.4335C7.03997 13.4335 6.0733 13.1735 5.2333 12.6669L5.0333 12.5535L2.9533 13.1002L3.50664 11.0735L3.3733 10.8602C2.8226 9.98598 2.53131 8.97342 2.5333 7.9402C2.53997 4.91353 4.99997 2.44687 8.0333 2.44687ZM5.68664 4.88687C5.57997 4.88687 5.39997 4.92687 5.24664 5.09354C5.09997 5.2602 4.66664 5.66687 4.66664 6.47354C4.66664 7.28687 5.25997 8.06687 5.3333 8.1802C5.42664 8.29353 6.50664 9.9602 8.16664 10.6669C8.55997 10.8469 8.86664 10.9469 9.10664 11.0202C9.49997 11.1469 9.85997 11.1269 10.1466 11.0869C10.4666 11.0402 11.12 10.6869 11.26 10.3002C11.4 9.91353 11.4 9.58687 11.36 9.51353C11.3133 9.44687 11.2066 9.40687 11.04 9.33353C10.8733 9.2402 10.06 8.8402 9.9133 8.78687C9.75997 8.73353 9.66664 8.70687 9.53997 8.86687C9.4333 9.03353 9.1133 9.40687 9.01997 9.51353C8.91997 9.62687 8.82664 9.6402 8.66664 9.5602C8.4933 9.47353 7.95997 9.3002 7.3333 8.7402C6.83997 8.3002 6.5133 7.7602 6.4133 7.59353C6.3333 7.43353 6.40664 7.33353 6.48664 7.2602C6.55997 7.18687 6.66664 7.06687 6.7333 6.96687C6.81997 6.87353 6.84664 6.8002 6.89997 6.69353C6.9533 6.5802 6.92664 6.48687 6.88664 6.40687C6.84664 6.33353 6.5133 5.50687 6.3733 5.1802C6.23997 4.8602 6.10664 4.9002 5.99997 4.89354C5.90664 4.89354 5.79997 4.88687 5.68664 4.88687Z"
                                    fill="#CCCCCC"
                                />
                            </svg>
                            {{ data.device.nama_device }}
                        </span>
                    </div>
                </template>
                <template v-slot:card_body>
                    <div style="padding-top: 10px; margin: 0 -12px" class="d-grid-12" @click="openDetail(data)">
                        <div class="grid-cspan-4 j-self-center">
                            <div
                                class="wa-status-thumbnail d-flex-between-center"
                                style="background: black; justify-content: center;"
                            >
                                <img v-if="isImage(data.media_type)" :src="`${imageStore}${data.media_name}`" />
                                <label v-if="isText(data.media_type)" class="m-d-0 f-12 f-regular f-c-white">
                                    Caption
                                </label>
                                <img
                                    v-if="isVideo(data.media_type)"
                                    :src="`${imageStore}thumbnail/${data.thumb_name}`"
                                />
                            </div>
                        </div>
                        <div class="grid-cspan-8 p-l-8 p-r-12">
                            <div class="d-grid-12 m-d-8">
                                <div class="grid-cspan-11 f-regular f-14 f-c-black">
                                    <label class="m-d-0" v-if="data.caption">
                                        {{ data.caption }}
                                    </label>
                                    <label class="m-d-0 f-c-midgrey" v-else>
                                        <i>Tanpa caption</i>
                                    </label>
                                </div>
                                <div class="grid-cspan-1">
                                    <img v-if="false" src="@/assets/icon-sidebar/chevron.svg" alt="" />
                                    <img v-else src="@/assets/img/chevron-right 1.svg" alt="" />
                                </div>
                            </div>

                            <!-- Jadwal -->
                            <div class="m-d-8">
                                <div class="f-12 f-c-midgrey" v-if="isDailyPost(data.schedule_detail.hari)">
                                    <label class="m-d-0">
                                        <b>Ulangi setiap:</b> {{ data.schedule_detail.hari }} —
                                        {{ data.schedule_detail.jam }}
                                    </label>
                                </div>
                                <div
                                    class="f-12 f-c-midgrey"
                                    v-if="isOntimePost(data.schedule_detail.post_at, $moment)"
                                >
                                    {{ dateFormated(data.created_at, $moment) }}
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M3.71242 2.11753C4.5766 1.61829 5.58095 1.41702 6.57076 1.54474C7.56057 1.67246 8.48094 2.12207 9.19008 2.82433C9.89922 3.52658 10.3578 4.44251 10.4952 5.43103C10.5332 5.70454 10.3423 5.95708 10.0688 5.99509C9.79525 6.03311 9.54271 5.84219 9.5047 5.56868C9.39752 4.79742 9.03972 4.08279 8.48643 3.53488C7.93315 2.98697 7.21506 2.63617 6.44279 2.53652C5.67052 2.43687 4.8869 2.5939 4.21266 2.98342C3.73767 3.25783 3.26683 3.60862 2.91679 3.99985H3.99994C4.27608 3.99985 4.49994 4.22371 4.49994 4.49985C4.49994 4.776 4.27608 4.99985 3.99994 4.99985H1.99994C1.7238 4.99985 1.49994 4.776 1.49994 4.49985V2.49985C1.49994 2.22371 1.7238 1.99985 1.99994 1.99985C2.27608 1.99985 2.49994 2.22371 2.49994 2.49985V2.99996C2.88788 2.64055 3.32129 2.34349 3.71242 2.11753ZM1.93111 6.00461C2.20463 5.9666 2.45717 6.15752 2.49518 6.43103C2.60236 7.20229 2.96016 7.91692 3.51344 8.46483C4.06673 9.01274 4.78482 9.36354 5.55709 9.46319C6.32936 9.56284 7.11298 9.40581 7.78722 9.01629C8.26221 8.74188 8.73305 8.39109 9.08309 7.99985H7.99994C7.7238 7.99985 7.49994 7.776 7.49994 7.49985C7.49994 7.22371 7.7238 6.99985 7.99994 6.99985H9.99994C10.2761 6.99985 10.4999 7.22371 10.4999 7.49985V9.49985C10.4999 9.776 10.2761 9.99986 9.99994 9.99986C9.7238 9.99986 9.49994 9.776 9.49994 9.49985V8.99975C9.112 9.35916 8.67859 9.65622 8.28746 9.88218C7.42328 10.3814 6.41893 10.5827 5.42912 10.455C4.4393 10.3272 3.51894 9.87764 2.8098 9.17538C2.10065 8.47313 1.64207 7.5572 1.5047 6.56868C1.46669 6.29516 1.6576 6.04262 1.93111 6.00461Z"
                                            fill="#6F7287"
                                        />
                                    </svg>
                                </div>
                                <div
                                    class="f-12 f-c-midgrey"
                                    v-if="isSchedulePost(data.schedule_detail.post_at, $moment)"
                                >
                                    Terjadwal: {{ dateFormated(data.schedule_detail.post_at, $moment) }}
                                </div>
                            </div>

                            <!-- Per-status -->
                            <label
                                class="wa-status-status f-12 m-d-0"
                                :class="{
                                    blue: data.status === 1,
                                    green: data.status === 2,
                                    red: data.status === 3 || data.status === 4 || data.status === 0,
                                }"
                                v-if="data.status !== 0"
                            >
                                {{ getTypeStatus(data.status, data.type_data) }}
                                <span v-if="data.status === 3"> • {{ getReason(data.reason) }}</span>
                            </label>
                        </div>
                    </div>
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotCard from "@/so-components/global/slot/SOSlotCard";

import { moduleName } from "../store/state";

export default {
    name: "CardStatusWA",
    props: {
        dataList: {
            type: Array,
            required: true,
        },
        dataCount: {
            type: Number | String,
            default: 0,
        },
    },
    components: {
        SOSlotCard,
    },
    computed: {
        ...mapGetters(moduleName, {
            getTypeStatus: "getTypeStatus",
            dateFormated: "dateFormated",
            isFetching: "isFetching",
            storyAktifPage: "storyAktifPage",
            storyRiwayatPage: "storyRiwayatPage",
            isSchedulePost: "isSchedulePost",
            getPopUpLink: "getPopUpLink",
            isOntimePost: "isOntimePost",
            isDailyPost: "isDailyPost",
            imageStore: "imageStore",
            isVideo: "isVideo",
            isImage: "isImage",
            isText: "isText",
            endStoryAktif: "endStoryAktif",
            endStoryRiwayat: "endStoryRiwayat",
        }),
        getReason() {
            return (reason) => {
                return reason === "saldo_kurang" ? "M-coin tidak cukup" : "Masalah koneksi";
            };
        },
        getLastId() {
            if (this.isStoryAktif) {
                return this.endStoryAktif.id ? `status-${this.endStoryAktif.id}` : "";
            }

            if (this.isStoryRiwayat) {
                return this.endStoryRiwayat.id ? `status-${this.endStoryRiwayat.id}` : "";
            }
        },
        popUpLink() {
            return this.getPopUpLink(this.$route.name);
        },
        isStoryAktif() {
            return this.$route.name === "wa_status.status_aktif";
        },
        isStoryRiwayat() {
            return this.$route.name === "wa_status.riwayat_status";
        },
    },
    methods: {
        ...mapActions({
            toggleShowStoryAktif: `${moduleName}/toggleShowStoryAktif`,
            toggleShowStoryRiwayat: `${moduleName}/toggleShowStoryRiwayat`,
            setLoadMore: `${moduleName}/setLoadMore`,
            getStoryAktif: `${moduleName}/getStoryAktif`,
            getRiwayatStory: `${moduleName}/getRiwayatStory`,
            getDetailStory: `${moduleName}/getDetailStory`,
            getDetailStatus: `${moduleName}/getDetailStatus`,
            setFetching: `${moduleName}/setFetching`,
            setResponse: `${moduleName}/setResponse`,
            setPreview: `${moduleName}/setPreview`,
        }),
        async doLoadMore() {
            if (this.isStoryAktif) {
                if (this.dataCount > this.storyAktifPage.length) {
                    if (!this.isFetching) {
                        await this.setLoadMore(true);
                        await this.getStoryAktif({ iddevice: this.$route.params.aktif_id });
                    }
                }
            }

            if (this.isStoryRiwayat) {
                if (this.dataCount > this.storyRiwayatPage.length) {
                    if (!this.isFetching) {
                        await this.setLoadMore(true);
                        await this.getRiwayatStory({ iddevice: this.$route.params.iddevice });
                    }
                }
            }
        },
        toggleCard(data) {
            if (this.isStoryAktif) {
                this.toggleShowStoryAktif(data);
            }
            if (this.isStoryRiwayat) {
                this.toggleShowStoryRiwayat(data);
            }
        },
        async openDetail(data) {
            let { type_data, schedule_detail, id, device } = data;

            if (this.isDailyPost(schedule_detail.hari)) {
                this.$router.push({
                    name: "wa_status.detail_status",
                    query: { idStatus: id, iddevice: device.iddevice },
                });
            } else {
                this.getDetailStory({ idstory: data.id })
                    .then((res) => {
                        let { status, code, msg } = res.data;
                        if (status && code === 200) {
                            this.setPreview(res.data.data);
                            switch (data.status) {
                                case 1:
                                    this.$router.push({ name: this.popUpLink.tayang });
                                    break;
                                case 2:
                                    this.$router.push({ name: this.popUpLink.diposting });
                                    break;
                                case 0:
                                    this.$router.push({ name: this.popUpLink.terjadwal });
                                    break;
                                case 3:
                                    this.$router.push({ name: this.popUpLink.gagal });
                                    break;
                                case 4:
                                default:
                                    break;
                            }
                        }
                        this.setFetching(false);
                    })
                    .catch((e) => {
                        this.setFetching(false);
                    });
            }
        },
    },
};
</script>

<style scoped>
.wa-device-container {
    margin: -10px 0 0 -18px;
}

.wa-device {
    background: #f6f6f6;
    border-top-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    padding: 4px 8px;
    max-width: 200px;

    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.wa-status-thumbnail {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    border-radius: 8px;
    border-color: #ededed;
    height: 100px;
    width: 100px;
}

.wa-status-thumbnail img {
    height: auto;
    width: 100%;
}

.wa-status-status {
    border-radius: 4px;
    padding: 2px 4px;
}

.wa-status-status.green {
    color: #40964c;
    background-color: #e8fcee;
}

.wa-status-status.red {
    color: #964040;
    background-color: #fff1f1;
}

.wa-status-status.blue {
    color: #206cff;
    background-color: #e2f0ff;
}
</style>
